module.exports = __webpack_public_path__ + "img/what.a6b34074.png";